import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { of, throwError } from 'rxjs';
import { retryWhen, delay, take, tap, mergeMap } from 'rxjs/operators';
import { PartenaireType } from 'src/models/partenaire-type';
import { PartenaireTypeService } from 'src/services/partenaire-type/partenaire-type.service';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {
  partenairesType: Array<PartenaireType>;
  loading: boolean;
  search: string;

  constructor(private partenaireTypeService: PartenaireTypeService, private meta: Meta) {}

  ngOnInit(): void {
    this.meta.addTag({ name: 'description', content: "Acheteurs & Partenaires" });
    this.meta.addTag({ name: 'keywords', content: 'BSTP Guinée, BSTP, bstpgn, ' });
    this.meta.addTag({ name: 'author', content: 'BSTP Guinée' });

    this.loading = true;
    this.partenaireTypeService.list().pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error) => {
            // Si c'est une erreur serveur (500+), on réessaie après un délai
            if (error.status >= 500) {
              console.log("Erreur serveur, nouvelle tentative...");
              return of(error).pipe(delay(500));
            }
            // Sinon (404, 400, etc.), on propage immédiatement l'erreur
            return throwError(() => error);
          }),
          take(3) // Max 3 tentatives pour les erreurs 5xx
        )
      )
    ).subscribe({
      next: data => {
        this.partenairesType = data;
        this.loading = false;
        this.animateCounters();
      },
      error: error => this.loading = false,
    });
  }

  get filteredPartenaires() {
    if (this.search === null || this.search === undefined || this.search === '') {
      return this.partenairesType;
    }
    return this.partenairesType.filter(item =>
      item.name.toLowerCase().includes(this.search.toLowerCase()) ||
      item.partenaires.some(p =>
        p.name.toLowerCase().includes(this.search.toLowerCase())
      )
    );
  }

  // Propriétés calculées pour les statistiques
  get totalPartners() {
    if (!this.partenairesType) return 0;
    return this.partenairesType.reduce((total, category) => {
      return total + (category.partenaires?.length || 0);
    }, 0);
  }

  get totalCategories() {
    return this.partenairesType?.length || 0;
  }

  get totalProjects() {
    if (!this.partenairesType) return 0;
    // Simulation basée sur le nombre de partenaires
    return this.totalPartners * 5;
  }

  get totalYears() {
    if (!this.partenairesType) return 0;
    // Simulation basée sur le nombre de catégories
    return this.totalCategories * 2;
  }

  // Méthodes pour les actions
  contactPartner(partenaire: any) {
    console.log('Contacter partenaire:', partenaire);
    // Implémentation pour contacter le partenaire
  }

  viewDetails(partenaire: any) {
    console.log('Voir détails partenaire:', partenaire);
    // Implémentation pour voir les détails
  }

  clearSearch() {
    this.search = '';
  }

  animateCounters() {
    setTimeout(() => {
      const counters = document.querySelectorAll('.stat-number');
      counters.forEach(counter => {
        const target = parseInt(counter.getAttribute('data-count') || '0');
        const duration = 2000;
        const increment = target / (duration / 16);
        let current = 0;
        
        const timer = setInterval(() => {
          current += increment;
          if (current >= target) {
            current = target;
            clearInterval(timer);
          }
          counter.textContent = Math.floor(current).toString();
        }, 16);
      });
    }, 500);
  }
}
